import type {ReactNode} from 'react';

import {cn} from '@ds/helpers';
import emptyIllustration from 'assets/images/empty-list.svg';

export type EmptyProps = {
  children?: ReactNode;
  illustration?: string;
  className?: string;
};

export function Empty({children, illustration = emptyIllustration, className}: EmptyProps) {
  return (
    <div className={cn('relative z-[1] flex flex-col items-center justify-center', className)}>
      <img src={illustration} alt="" aria-hidden className="pointer-events-none select-none" />
      {children ? <div className="relative z-[1]">{children}</div> : null}
    </div>
  );
}

export default Empty;
